/* eslint-disable no-console */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/sort-comp */
import React from 'react';
import {
  browserName,
  browserVersion,
  osName,
  osVersion,
} from 'react-device-detect';
import axios from 'axios';
import { EmailErrorService } from 'services/EmailError/EmailErrorService';
import PageErrorBoundary from './ErrorBoundaryPage';
import { getUri } from '../../utils/uri';
import { withUserDataHOC } from '../../hoc/withUserData.hoc';

class ErrorBoundaryClass extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  async componentDidCatch(error, errorInfo) {
    const uri = getUri(window.location.hostname);
    const token = localStorage.getItem('accessToken');
    const userId = this.props.userData.id;

    const headers = {
      'content-type': 'application/json',
      authorization: `Bearer ${token}`,
    };
    const query = `query {
      userAccesses(userId:"${userId}") {
        user {
          email
          role
          name
        },
        site {
          domain
        }
      }
    }`;

    const userRequest = await axios({
      url: uri,
      method: 'POST',
      data: {
        query,
      },
      headers,
    });

    let emailErrorData = {
      location: window.location.href,
      os: osName,
      os_version: osVersion,
      browser_version: browserVersion,
      browser_name: browserName,
      error: error.toString(),
      error_info: errorInfo.componentStack,
    };

    if (userRequest.data.data) {
      const userInfo = userRequest.data.data.userAccesses[0].user;
      const userDataToEmailError = {
        user_id: userId,
        user_role: userInfo.role,
        user_email: userInfo.email,
        user_name: userInfo.name,
      };

      emailErrorData = {
        ...emailErrorData,
        ...userDataToEmailError,
      };
    }

    EmailErrorService.sendMailError(emailErrorData);
  }

  render() {
    if (this.state.hasError) return <PageErrorBoundary />;
    return this.props.children;
  }
}

export const ErrorBoundary = withUserDataHOC(ErrorBoundaryClass);
